import {SYSTEMSETTING} from 'Constants/ActionTypes';

const {
  GET_EXPORT_TASK_LIST,
  SET_EXPORT_TASK_PAGE_STATUS,
  SET_EXPORT_TASK_DOWNLOAD,
  SET_EXPORT_TASK_RELOAD,
} = SYSTEMSETTING;

const initialState = {
  tableListData: {
    data: [],
    total: 0,
  }, // table数据
  pageStatus: {
    pageNum: 1,
    pageSize: 20,
  }, // pageNum与pageSize
  downloadModalData: {},
  reloadModalData: {},
};

const exportTasks = (state = initialState, action) => {
  switch (action.type) {
    case `${GET_EXPORT_TASK_LIST}_SUCCESS`:
      return {
        ...state,
        tableListData: {
          data: (action.payload.data && action.payload.data.list) || [],
          total: (action.payload.data && action.payload.data.total) || 0,
        },
      };
    case `${GET_EXPORT_TASK_LIST}_FAIL`:
      return {
        ...state,
        tableListData: {
          data: [],
          total: 0,
        },
      };
    case `${SET_EXPORT_TASK_PAGE_STATUS}`:
      return {
        ...state,
        pageStatus: {...state.pageStatus, ...action.data},
      };
    case `${SET_EXPORT_TASK_DOWNLOAD}`:
      return {
        ...state,
        downloadModalData: action.data,
      };
    case `${SET_EXPORT_TASK_RELOAD}`:
      return {
        ...state,
        reloadModalData: action.data,
      };
    default:
      return state;
  }
};

export default exportTasks;
